<template>
  <v-dialog
    :value="value"
    content-class="modal modal-round"
    :max-width="maxWidth"
    :persistent="persistent"
    @input="emitValEvents"
  >
    <div v-if="!persistent" class="close" @click="hideModal">&times;</div>

    <v-card style="padding: 6px 10px">
      <v-card-title class="headline">
        <slot name="heading"></slot>
      </v-card-title>

      <v-card-text>
        <slot></slot>
      </v-card-text>

      <v-card-actions :class="{ 'v-card-one-button': isOnlyOneButton }">
        <v-spacer v-if="!isOnlyOneButton"></v-spacer>

        <v-btn :color="getColor(palette.primary)" flat @click="$emit('confirm')">
          {{ confirmLabel }}
        </v-btn>

        <v-btn
          v-if="!isOnlyOneButton"
          color="#707070"
          flat
          @click="$emit('cancel')"
        >
          {{ cancelLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { i18n } from "@packages/I18n";
import provider from "@mixins/provider";
import colors from "../packages/mixins/colors";

export default {
  props: {
    value: {
      type: Boolean,
    },

    persistent: {
      type: Boolean,
      default: true,
    },

    confirmLabel: {
      type: String,
      default: i18n.t("message.generics.message.confirm"),
    },

    cancelLabel: {
      type: String,
      default: i18n.t("message.generics.message.cancel"),
    },

    maxWidth: {
      type: Number,
      default: 310,
    },

    isOnlyOneButton: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [provider, colors],

  computed: {},

  methods: {
    emitValEvents(val) {
      if (val) {
        this.$emit("opened");
      } else {
        this.$emit("closed");
      }

      this.$emit("input", val);
    },
    hideModal() {
      this.$emit("input", false);
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
.v-card-one-button {
  justify-content: center;
}
</style>
